/* CostCenters.tsx
	Page affichant la gestion des centres de coûts
	Utilise CostCentersCrudCard pour bénéficier de la pagination, du tri et des filtres côté serveur
*/

// Import FontAwesome
import { faCube } from '@fortawesome/free-solid-svg-icons';

// Import Feature
import { CostCentersCrudCard } from 'features/costCenter';

// Import Layout
import PageHeader from 'layout/PageHeader';

export const CostCenters = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faCube}
			title="Centres de coûts"
			subtitle="Gérez les centres de coûts"
		/>
		<CostCentersCrudCard
			size="lg"
			returnPath="/app/settings/depenses"
			returnLabel="Paramètres dépenses"
			className="mt-6"
		/>
	</div>
);
